import { AREA_MASTER } from "../../../../../../../../constants/areaMaster";
import { PREFECTURE_MASTER } from "../../../../../../../../constants/prefectureMaster";

import type { GroupedPrefectureMasterRecord } from "../../../../components/PrefecturesSelector/types/groupedPrefectureMasterRecord";

const {
  chubu,
  hokkaidoTohoku,
  hokushinnetsu,
  kansai,
  kanto,
  kyushu,
  others,
  shikokuChugoku,
} = AREA_MASTER;

const {
  hokkaido,
  aomori,
  iwate,
  miyagi,
  akita,
  yamagata,
  fukushima,
  ibaraki,
  tochigi,
  gunma,
  saitama,
  chiba,
  tokyo,
  kanagawa,
  niigata,
  toyama,
  ishikawa,
  fukui,
  yamanashi,
  nagano,
  gifu,
  shizuoka,
  aichi,
  mie,
  shiga,
  kyoto,
  osaka,
  hyogo,
  nara,
  wakayama,
  tottori,
  shimane,
  okayama,
  hiroshima,
  yamaguchi,
  tokushima,
  kagawa,
  ehime,
  kochi,
  fukuoka,
  saga,
  nagasaki,
  kumamoto,
  oita,
  miyazaki,
  kagoshima,
  okinawa,
} = PREFECTURE_MASTER;

export const GROUPED_PREFECTURES_BASE: GroupedPrefectureMasterRecord[] = [
  {
    ...hokkaidoTohoku,
    prefectures: [hokkaido, aomori, iwate, miyagi, akita, yamagata, fukushima],
  },
  {
    ...hokushinnetsu,
    prefectures: [niigata, toyama, ishikawa, fukui, nagano],
  },
  {
    ...kanto,
    prefectures: [ibaraki, tochigi, gunma, saitama, chiba, tokyo, kanagawa],
  },
  {
    ...chubu,
    prefectures: [yamanashi, gifu, shizuoka, aichi, mie],
  },
  {
    ...kansai,
    prefectures: [shiga, kyoto, osaka, hyogo, nara, wakayama],
  },
  {
    ...shikokuChugoku,
    prefectures: [
      tottori,
      shimane,
      okayama,
      hiroshima,
      yamaguchi,
      tokushima,
      kagawa,
      ehime,
      kochi,
    ],
  },
  {
    ...kyushu,
    prefectures: [
      fukuoka,
      saga,
      nagasaki,
      kumamoto,
      oita,
      miyazaki,
      kagoshima,
      okinawa,
    ],
  },
  {
    ...others,
    prefectures: [],
  },
];
